<template>
    <div class="additional-menu">
        <ul class="additional-menu__list">
            <li v-for="(item, index) in menuList" :key="index" class="additional-menu__item">
                <a :href="item.link" :title="item.title" class="additional-menu__link" @click.prevent="onMenuClick">
                    <p class="additional-menu__text">
                        {{ item.title }}
                    </p>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'the-menu-additional-menu',
  data () {
    return {
      menuList: [
        {
          title: 'В разработке',
          link: '#1'
        },
        {
          title: 'В разработке',
          link: '#2'
        },
        {
          title: 'В разработке',
          link: '#3'
        }
      ]
    }
  },
  methods: {
    onMenuClick () {

    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/css/system/_vars';
  @import '../../assets/css/system/_mixins';

    .additional-menu {
        background-color: $color_second-dark;
        padding-top: 10px;
        padding-bottom: 10px;

        &__list {
            height: auto;
            max-height: 150px; //три высоты пункта
            overflow: auto;

            &::-webkit-scrollbar {
                width: 12px;
            }

            &::-webkit-scrollbar-track {
                /* background-color: transparentize($color_main, .6); */
                background: linear-gradient(90deg, transparentize($color_main, .6) 0%, transparentize($color_main, .6) 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
            }

            &::-webkit-scrollbar-thumb {
                /* background-color: transparentize($color_main, .4); */
                background: linear-gradient(90deg, transparentize($color_main, .4) 0%, transparentize($color_main, .4) 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
            }
        }

        &__link {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px;
            height: 50px;
            cursor: pointer;
            transition: .3s;
            color: $font_color_alt;

            &:hover {
                background-color: $color_second-light;
            }
        }

        &__text {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
</style>
